'use client';
import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef, useState } from 'react';
import classnames from 'classnames';
import { Button } from '../Button/index.js';
import { Body } from '../Body/Body.js';
import { IconX } from '../Icons/Status/X.js';
import { IconInfoCircle } from '../Icons/Status/InfoCircle.js';
import { IconCheckCircle } from '../Icons/Status/CheckCircle.js';
import { IconAlertCircle } from '../Icons/Status/AlertCircle.js';

const iconMap = {
  info: IconInfoCircle,
  success: IconCheckCircle,
  warning: IconAlertCircle,
  error: IconAlertCircle,
  generic: null
};
const Alert = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    type = 'generic',
    layout = 'inline',
    className,
    icon,
    close,
    messageProps = {},
    actionProps = {},
    children
  } = _ref;
  const [isClosed, setIsClosed] = useState(false);
  const {
    enabled: iconEnabled = false,
    component: IconComponent
  } = icon || {};
  const Icon = IconComponent || iconMap[type];
  const CloseIcon = close?.component || IconX;
  const handleOnClose = () => {
    setIsClosed(true);
    if (close?.callback) close.callback();
  };
  if (isClosed || !children) return null;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames('b-alert', `b-alert--${type}`, `b-alert--${layout}`, className),
    "data-testid": "alert",
    ref: ref
  }, iconEnabled && Icon && /*#__PURE__*/React__default.createElement("div", {
    className: "b-alert__icon"
  }, /*#__PURE__*/React__default.createElement(Icon, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "b-alert__content"
  }, /*#__PURE__*/React__default.createElement(Body, _extends({
    type: "p",
    variant: "body-sm",
    modifier: 500
  }, messageProps), children), actionProps?.children && /*#__PURE__*/React__default.createElement("div", {
    className: "b-alert__action"
  }, /*#__PURE__*/React__default.createElement(Button, _extends({
    variant: "plain",
    size: "small"
  }, actionProps)))), close?.enabled && /*#__PURE__*/React__default.createElement("div", {
    className: "b-alert__close"
  }, /*#__PURE__*/React__default.createElement(Button, {
    variant: "plain",
    onClick: handleOnClose
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null))));
});
Alert.displayName = 'Alert';

export { Alert };
